<template>
    <footer id="contact" class="main-bg pt-5 pb-5">
      <div class="container">
        <div class="row">
          <div class="col-auto mr-auto">
            <div class="footer-logo">
              <a href="/"><img src="../assets/images/logo.png" alt="img"></a>
            </div>
          </div>
        </div>
        <hr class="pt-5">
        <div class="pt-3">
          <div class="row justify-content-between">
            <div class="col-auto mr-auto">
              <ul class="list-inline">
                <li class="list-inline-item"><a href="/terms-and-conditions" class="text-white f-14"> 利用規約</a></li>
              </ul>
            </div>
            <div class="col-auto">
              <!-- <div class="social-icone">
                <ul>
                  <li class="d-inline"><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                  <li class="d-inline"><a href="#"><i class="fab fa-twitter"></i></a></li>
                  <li class="d-inline"><a href="#"><i class="fab fa-google"></i></a></li>
                  <li class="d-inline"><a href="#"><i class="fab fa-pinterest"></i></a></li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- back-to-top -->
      <div id="back-to-top">
        <a class="top" id="top" href="#top"><span>Scroll Up</span> <i class="ion-ios-arrow-thin-up"></i></a>
      </div>
      <!-- back-to-top End -->
      <!--=================================
         Cookies -->
      <div id="cookie_div" class="align-items-center"> We use cookies to give you tailored experiences on our website.
          <a class="button grey text-right ml-3" href="#" role="button" id="cookie">Accept </a>
      </div>
       <!--=================================
          Cookies -->
    </footer>
</template>

<script>
export default {
  name: 'Footerbar'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.f-14{
  font-size: 14px;
}
</style>